import TpInput from './input';
import TpTextarea from './textarea';
import UploadImg from './uploadImg';
import InputUploadImg from './inputUploadImg';
import CheckboxSelect from './checkboxSelect';
export default {
  TpInput,
  TpTextarea,
  UploadImg,
  InputUploadImg,
  CheckboxSelect
}



// WEBPACK FOOTER //
// ./src/components/form/form.js